module.exports = __webpack_public_path__ + "img/icon12.2364f6b3.png";